import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, TABLE_HEADER_CODE, JSON_KEY_STATUS,
   TABLE_HEADER_STATUS, ConvertStatus, TABLE_HEADER_DESCRIPTION, JSON_KEY_DESCRIPTION, 
   DROPDOWN_LIST_NONE, AddItemToDropdown, UPDATE_ROW, DELETE_ROW, 
   JSON_KEY_INDEX, JSON_KEY_PRICE_DECIMALS, 
   JSON_KEY_PRICE, FormatWithDecimals, TABLE_HEADER_VALUE,
   TABLE_HEADER_DIVISOR,
   JSON_KEY_DIVISOR,
   TABLE_HEADER_DECIMALS,
   TABLE_HEADER_MINIMUM_VALUE,
   JSON_KEY_MININMUM_VALUE,
   TABLE_HEADER_MAXIMUM_VALUE,
   JSON_KEY_MAXINMUM_VALUE,
   JSON_KEY_VALIDATE_ORDERS,
   TABLE_HEADER_VALIDATE_ORDERS,
   // TABLE_HEADER_HIGH, TABLE_HEADER_LOW, JSON_KEY_LOW, JSON_KEY_HIGH,
   TABLE_HEADER_CALCULATION_TYPE,
   JSON_KEY_CALCULATION_TYPE
} 
from '../../common/common';
import { useSelector } from 'react-redux';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { Modal } from 'react-bootstrap';
import IndicesAdminForm from '../forms/indices_admin_form';
import { MSG_TYPE_INDICES_REPLY } from '../../common/msg_types';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';
import { ConvertFromCalculationType, ConvertToTradingRulesValueName } from '../../common/convert_functions';
import { instrumentCodeColor, statusTextColor, rowOpacityForStatus } from '../../common/common';

const Indices = () => {
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownIndicesData, setDropDownIndicesData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);
   
   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[IndicesTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[IndicesTable] Row Double Clicked:`, rowData);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('results details: ', details.data, 'r_type:', details.data.r_type, ', Message:');
      
      const modifiedRow = {
         ...details.data,
         id: details.data.idx,
         div: details.data.div != null ? FormatWithDecimals(details.data.div, 0) : "",
         calc: ConvertFromCalculationType(details.data.calc),
         price: FormatWithDecimals(details.data.price, details.data.price_dec),
         min: details.data.min != null ? FormatWithDecimals(details.data.min, details.data.price_dec) : " ",
         max: details.data.max != null ? FormatWithDecimals(details.data.max, details.data.price_dec) : " ",
         val_ord: ConvertToTradingRulesValueName(details.data.val_ord),
         // highValue: details.data.price,
         // lowValue: details.data.price,
         // high: FormatWithDecimals(details.data.price, details.data.price_dec),
         // low: FormatWithDecimals(details.data.price, details.data.price_dec),
         status: ConvertStatus(details.data.status),     
      };

      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prev => {
               // console.log('results details: ', details.data, 'r_type:', details.data.r_type, ', Message:', details.data.message, ', message:', JSON.stringify(details.data.message));
               const exists = prev.some(row => row.id === modifiedRow.id);
               if (exists) {
                  // console.log(`Duplicate message with id ${modifiedRow.id} ignored.`);
                  return prev;
               }
               return [...prev, modifiedRow];
            });

            AddItemToDropdown(setDropDownIndicesData, { id: details.data.idx, name: details.data.idx });
            // console.log('Add Row low ',modifiedRow.low, ',high: ', modifiedRow.high, ', price: ', modifiedRow.price);

            break;

         case UPDATE_ROW:
            if (isMarketControllerRef.current && (details.data.m_type === MSG_TYPE_INDICES_REPLY)) {
               break;
            }

            setLocalTableData(prevData =>
               prevData.map(row => {
                  if (row.id !== modifiedRow.id)
                     return row;

                  // const decimals = details.data.price_dec;

                  // Previous numeric values
                  // const previousHigh = row.highValue;
                  // const previousLow  = row.lowValue;

                  // Current numeric price
                  // const currentPrice = details.data.price;

                  // Calculate new numeric high/low
                  // const newHigh = previousHigh == null ? currentPrice : Math.max(previousHigh, currentPrice);
                  // const newLow = previousLow == null ? currentPrice : Math.min(previousLow, currentPrice);

                  return {
                     ...row,
                     ...modifiedRow,

                     // highValue: newHigh,
                     // lowValue: newLow,

                     // high: FormatWithDecimals(newHigh, decimals),
                     // low: FormatWithDecimals(newLow, decimals),
                  };
               })
            );

           break;

         case DELETE_ROW:
            setLocalTableData(prevData => prevData.filter(row => row.id !== modifiedRow.id));
            break;

         default:
            console.log('Unknown event type:', details.type);
            break;
      }
   }, []);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_INDEX] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);

   const columns = useMemo(() => [
      { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_INDEX },
      { Header: TABLE_HEADER_DESCRIPTION, accessor: JSON_KEY_DESCRIPTION },
      { Header: TABLE_HEADER_VALUE, accessor: JSON_KEY_PRICE },
      // { Header: TABLE_HEADER_LOW, accessor: JSON_KEY_LOW },
      // { Header: TABLE_HEADER_HIGH, accessor: JSON_KEY_HIGH },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
      ...(isMarketController ? [
         { Header: TABLE_HEADER_DIVISOR, accessor: JSON_KEY_DIVISOR },
         { Header: TABLE_HEADER_CALCULATION_TYPE, accessor: JSON_KEY_CALCULATION_TYPE },
         { Header: TABLE_HEADER_MINIMUM_VALUE, accessor: JSON_KEY_MININMUM_VALUE },
         { Header: TABLE_HEADER_MAXIMUM_VALUE, accessor: JSON_KEY_MAXINMUM_VALUE },
         { Header: TABLE_HEADER_VALIDATE_ORDERS, accessor: JSON_KEY_VALIDATE_ORDERS },
         { Header: TABLE_HEADER_DECIMALS, accessor: JSON_KEY_PRICE_DECIMALS },
      ] : []),
      // { Header: TABLE_HEADER_LOW, accessor: JSON_KEY_LOW },
   ], [isMarketController]);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="IndicesTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
            
         <Modal show={showForm} onHide={handleCloseForm}>
            <IndicesAdminForm rowData={selectedRow} onClose={handleCloseForm} indicesOptions={dropDownIndicesData} />
         </Modal>
      </>
   );
};

export default Indices;
